import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import ToggleSwitch from 'components/form-components/ToggleSwitch';
import TextField from 'components/form-components/TextField';
import NestedSelect from 'components/form-components/NestedSelect';
import SingleCheckBoxField from 'components/form-components/SingleCheckBoxField';

const TicketDetailProperties = ({ properties, handleChange, ticketTypeOptions }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className='d-flex gap-2 align-items-center'>
        <ToggleSwitch
          name='ticketEnabled'
          value={properties['ticketEnabled']}
          handleChange={handleChange}
        />
        <label>{t('field_enable_tickets')}</label>
      </div>
      {properties['ticketEnabled'] && (
        <>
          <TextField
            name={'ticketTitle'}
            value={properties['ticketTitle']}
            displayName={'form_field_ticket_title'}
            handleChange={handleChange}
            classes='mt-2'
            shrink
          />
          <NestedSelect
            options={ticketTypeOptions}
            name='ticketDefaultType'
            displayName={'form_field_ticket_default_type'}
            handleChange={handleChange}
            shrink
            toggleClasses='p-2 border-grey-1-h-1 mt-2'
            toggleComponent={
              <>
                <label className='theme-size-0_9 cursor-pointer'>
                  {ticketTypeOptions.find((t) => t.value === properties['ticketDefaultType'])
                    ?.displayValue ?? t('select_default_type')}
                </label>
                <img src={chevronGreyIcon} className='rotate-180' />
              </>
            }
            fullWidth
          />
          <SingleCheckBoxField
            disabled={!properties['ticketDefaultType']}
            name='allowTicketTypeSelection'
            value={properties['allowTicketTypeSelection']}
            handleChange={handleChange}
            text={<span>{t('form_field_allow_user_ticket_type_section')}</span>}
            classes='mt-3'
            shrink
          />
        </>
      )}
    </div>
  );
};

TicketDetailProperties.propTypes = {
  properties: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  ticketTypeOptions: PropTypes.array.isRequired,
};

export default TicketDetailProperties;
